import { useCallback } from "react";
import { useNavigate } from "react-router";

import { Toast } from "@covertree/utils";
import { useFindPolicyForClaimLazyQuery } from "@api/operations.generated";
import { useAppDispatch } from "@redux/hooks";
import { setPolicyLocator, setPropertyAddress } from "@redux/slices";
import { StepPath } from "@routing/paths";

import { MissingPolicyDetailsForm } from "./form";

export function useFindPolicyFormClaimByLocator() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [findPolicyForClaim, { loading }] = useFindPolicyForClaimLazyQuery();

  const submit = useCallback(
    async ({ policyLocator }: MissingPolicyDetailsForm) => {
      const { data } = await findPolicyForClaim({
        variables: {
          input: {
            policyLocator: policyLocator,
          },
        },
      });
      dispatch(setPolicyLocator(policyLocator));
      dispatch(setPropertyAddress(undefined));
      if (data?.findPolicyForClaim) {
        navigate(`/${StepPath.LOSS_LOCATION_DETAILS}`);
      } else {
        Toast.showError("The policy has not been found");
      }
    },
    [findPolicyForClaim, dispatch, navigate]
  );

  return {
    findPolicyForClaim: submit,
    loading,
  };
}
